exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tech-features-wrapper .features[data-v-818d9624] {\n  flex-basis: auto;\n}\n.container-db[data-v-818d9624] {\n  margin-top: 50px;\n}\n.container-info[data-v-818d9624], .container-mark[data-v-818d9624] {\n  line-height: 1.8;\n}", ""]);

// exports
